"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import { Check } from "lucide-react";
import type React from "react";

const Checkbox: React.FC<
  React.ComponentProps<typeof CheckboxPrimitive.Root> & {
    iconClassName?: string;
  }
> = ({ ref, className, iconClassName, ...props }) => (
  <CheckboxPrimitive.Root
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className={cn("h-4 w-4", iconClassName)} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
